function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { ProgressChart } from "./PersonalDashboard";
import { Button, ProgressBar } from "react-bootstrap";
import statsDown from "../img/stats-down.jpg";
import statsUp from "../img/stats-up.jpg";
import classNames from "classnames";
import { convertToHoursAndMinutes } from "../utils";
import "./widget.css";
import moment from "moment-timezone";
import { useQuery } from "@apollo/client";
import { USER_TOP_APPS_USED_QUERY, PERSONAL_DASHBOARD_METRICS_QUERY } from "./query";
import { formatMetrics, getProgressDirection } from "./PersonalDashboard";
var stats = [{
  label: "Productive Hours",
  value: "03:10 h",
  status: "good"
}, {
  label: "Avg. Productive Hours",
  value: "05:10 h"
}];
var apps = [{
  name: "Google drive",
  status: "productive",
  icon: "https://ssl.gstatic.com/docs/doclist/images/infinite_arrow_favicon_5.ico",
  time: 80
}, {
  name: "Chat | Dashboard",
  status: "neutral",
  icon: "http://beta.designqube.com/dq_favicon.png",
  time: 80
}, {
  name: "Gmail",
  status: "productive",
  icon: "https://ssl.gstatic.com/ui/v1/icons/mail/images/favicon5.ico",
  time: 10
}, {
  name: "Facebook",
  status: "unproductive",
  icon: "https://facebook.com/favicon.ico",
  time: 30
}, {
  name: "Twitter",
  status: "unproductive",
  icon: "https://twitter.com/favicon.ico",
  time: 15
}, {
  name: "Figma",
  status: "productive",
  icon: "https://static.figma.com/app/icon/1/favicon.ico",
  time: 10
}, {
  name: "Pixlr",
  status: "neutral",
  icon: "https://pixlr.com/images/pixlr-favicon3-grey-16x16.ico",
  time: 100
}
// {
//   name: "The Incredible India and The world of the 21st century",
//   status: "neutral",
//   icon: "http://theincredibleindiaandtheworldofthe21stcentury.in/favicon.ico",
//   time: 20,
// },
];
var Widget = function Widget(props) {
  var LinkComponent = props.linkComponent;
  var _React$useState = React.useState({
      startDate: Number(moment().subtract(30, "days").format("x")),
      // startDate: Number(moment().startOf("day").format("x")),
      endDate: Number(moment().endOf("day").format("x"))
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dates = _React$useState2[0],
    setDates = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    focusedRow = _React$useState4[0],
    setFocusedRow = _React$useState4[1];
  var startDate = dates.startDate,
    endDate = dates.endDate;
  var _useQuery = useQuery(USER_TOP_APPS_USED_QUERY, {
      variables: {
        startDate: startDate,
        endDate: endDate
      }
    }),
    appsData = _useQuery.data,
    appsLoading = _useQuery.loading,
    appsError = _useQuery.error;
  var _useQuery2 = useQuery(PERSONAL_DASHBOARD_METRICS_QUERY, {
      variables: {
        startDate: startDate,
        endDate: endDate
      }
    }),
    workData = _useQuery2.data,
    workLoading = _useQuery2.loading,
    workError = _useQuery2.error;
  var appTotalTime = React.useMemo(function () {
    var apps = appsData === null || appsData === void 0 ? void 0 : appsData.userTopAppsUsed;
    if (!apps) return 0;
    return apps.reduce(function (acc, curr) {
      var newAcc = acc + curr.timeSpentInMins;
      return newAcc;
    }, 0);
  }, [appsData === null || appsData === void 0 ? void 0 : appsData.userTopAppsUsed]);
  var rows = React.useMemo(function () {
    var work = workData === null || workData === void 0 ? void 0 : workData.personalDashboardMetrics;
    if (!work) return [];
    return [["Productive", work.productiveMins], ["Unproductive", work.unproductiveMins], ["Neutral", work.neutralMins]];
  }, [workData === null || workData === void 0 ? void 0 : workData.personalDashboardMetrics]);
  if (appsLoading || workLoading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  if (appsError || workError) {
    return /*#__PURE__*/React.createElement("div", null, "Error");
  }
  if (!appsData || !workData) {
    return null;
  }
  var selectedRow = focusedRow || rows[0];
  var apps = appsData.userTopAppsUsed;
  var work = workData.personalDashboardMetrics;
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-dashboard-widget"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdw-first-section"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "pdw-greetings"
  }, "Hi Venkatesh,"), /*#__PURE__*/React.createElement(ProgressChart, {
    rows: rows,
    setFocusedRow: setFocusedRow,
    data: ["".concat(selectedRow[0], " hours"), "".concat(convertToHoursAndMinutes(selectedRow[1], "short"))]
  }), /*#__PURE__*/React.createElement(StatsGrid, {
    work: work
  })), /*#__PURE__*/React.createElement("div", {
    className: "pdw-second-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdw-ss-header"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "pdw-ss-header-text"
  }, "Mostly used apps & sites"), /*#__PURE__*/React.createElement(LinkComponent, {
    to: "/review-usage"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "outline-danger"
  }, "Review usage"))), /*#__PURE__*/React.createElement("div", {
    className: "pdw-ss-content"
  }, apps.map(function (app) {
    var _focusedRow$;
    var selected = !focusedRow ? true : ((_focusedRow$ = focusedRow[0]) === null || _focusedRow$ === void 0 ? void 0 : _focusedRow$.toLowerCase()) === app.productivityStatus;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("pdw-ss-app", {
        blur: !selected
      })
    }, /*#__PURE__*/React.createElement("img", {
      src: app.icon || "",
      className: "pdw-ss-app-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "pdw-ss-app-name"
    }, app.title), /*#__PURE__*/React.createElement(ProgressBar, {
      className: classNames("pdw-ss-app-time-progress", app.productivityStatus),
      now: Math.round(app.timeSpentInMins / appTotalTime * 100)
    }), /*#__PURE__*/React.createElement("p", {
      className: "pdw-ss-app-time"
    }, convertToHoursAndMinutes(app.timeSpentInMins, "short")));
  }))));
};
var StatsGrid = /*#__PURE__*/React.memo(function StatsGrid(props) {
  var work = props.work;
  var stats = React.useMemo(function () {
    return {
      productiveMins: {
        status: getProgressDirection(work.productiveMins, work.avgProductiveMins),
        value: work.productiveMins
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "pdw-history"
  }, /*#__PURE__*/React.createElement(Stats, _extends({
    label: "Productive Hours"
  }, stats.productiveMins)), /*#__PURE__*/React.createElement(Stats, {
    label: "Avg. Productive Hours",
    value: work.avgProductiveMins
  }));
});
var Stats = /*#__PURE__*/React.memo(function Stats(_ref) {
  var label = _ref.label,
    value = _ref.value,
    status = _ref.status;
  var good = status === "good";
  var bad = status === "bad";
  var displayValue = React.useMemo(function () {
    return formatMetrics(value, label.includes("Productivity"));
  }, [value, label]);
  return /*#__PURE__*/React.createElement("div", {
    key: "stats-grid-".concat(label),
    className: classNames("pdw-history-item", {
      good: good
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, label, good || bad ? /*#__PURE__*/React.createElement("img", {
    src: good ? statsUp : statsDown
  }) : null), /*#__PURE__*/React.createElement("h4", {
    className: classNames("content text-center", {
      disabled: displayValue === "Not available"
    })
  }, displayValue));
});
export default Widget;